import { articles } from "@/store/articles";
import { courses } from "@/store/courses";
import { lesson } from "@/store/lesson";
import { notes } from "@/store/notes";
import { testing } from "@/store/testing";
import { createStore } from 'vuex';
import { application } from "./application";
import { user } from "./user";


// creating Vuex store instance
const store = createStore({
	state: {},
	mutations: {},
	actions: {},
	modules: {
		user, application,courses,lesson,testing,articles, notes
	}
});

//store.dispatch('loadUserToken');

export default store;